import { Injectable } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VerifyService {

  authUrl = `${AppSettings.API_ENDPOINT}/${'get_company_validity'}`;
  emailUrl = `${AppSettings.API_ENDPOINT}/${'check-email-verify'}`;
  loginUrl = `${AppSettings.API_ENDPOINT}/${'login'}`;
  otpUrl = `${AppSettings.API_ENDPOINT}/${'verify-otp'}`;
  changePasswordUrl = `${AppSettings.API_ENDPOINT}/${'change-password-user'}`;
  freePlanUrl = `${AppSettings.API_ENDPOINT}/${'free-plan'}`
  forgotPasswordUrl = `${AppSettings.API_ENDPOINT}/${'forgot-password'}`;
  twoFactorLoginUrl = `${AppSettings.API_ENDPOINT}/${'send-mobile-otp'}`;
  verifyToken:any;

  // signUpEmitter: EventEmitter<any> = new EventEmitter();
  // em = false;
  constructor(private http : HttpClient) { 

  }
  
  getData(){
    return this.http.get(this.authUrl);
  }

  getEmail(email:any){
    return this.http.get(`${this.emailUrl}/${email}`);
  }

  postEmail(data:any){
 
    return this.http.post(this.loginUrl,data);
  }

  // sendEmitter(){
  //   this.signUpEmitter.emit(this.em);
  // }

  postOtp(data:any){
    return this.http.post(this.otpUrl, data);
  }

  getFreePlan(){
    return this.http.get(this.freePlanUrl);
  }
  postPassword(data:any){
    return this.http.post(this.changePasswordUrl, data);
  }

 

  forgotPasswordRest(email:string){
    let payload = {
      "email":email
    }
     return this.http.post(`${this.forgotPasswordUrl}`,payload);
  }

  twoFactorLogin(email:string){
    let payload = {
      "email":email
    }
     return this.http.post(`${this.twoFactorLoginUrl}`,payload);
  }  

  

   dateTimeToHex(): any {
     const now = new Date();
    // Format: HHMMSSYYYYDDMM
    const pad = (n: number) => n.toString().padStart(2, '0');
    const randomSalt = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    const milliseconds = now.getUTCMilliseconds().toString().padStart(3, '0') + '000';
    console.log("sec",milliseconds);
    const customTime =
      pad(now.getUTCHours()) +
      pad(now.getUTCMinutes()) +
      pad(now.getUTCSeconds()) +
      milliseconds+
      now.getUTCFullYear().toString() +
      pad(now.getUTCDate()) +
      pad(now.getUTCMonth() + 1) +"."+randomSalt;  // Months are 0-based
    // Encode to hex using TextEncoder
    const encoder = new TextEncoder();
    const encoded = encoder.encode(customTime);
    const hexTimestamp = Array.from(encoded).map(b => b.toString(16).padStart(2, '0')).join('');
    return hexTimestamp;
  }

}
